/**
 * @file blog-filter.js
 *
 */

(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.blogfilter = {
    attach: function (context, settings) {
      var toggle = $(".blog-filter-container #search-toggle");

      $(toggle, context).on("click", function (e) {
        e.preventDefault();
        $(this, context).parents(".blog-search").toggleClass("toggled");
      });

      $(".blog-filter ul", context)
        .clone()
        .addClass("dropdown")
        .insertAfter(".blog-filter .bef-links");

      $(".blog-filter .dropdown").each(function () {
        var list = $(this),
          select = $(document.createElement("select"))
            .addClass("blog-filter__dropdown")
            .attr("aria-label", "Blog Filter")
            .insertBefore($(this).hide())
            .change(function () {
              window.location.href = $(this).val();
            });
        $(">li a", this).each(function () {
          var option = $(document.createElement("option"))
            .appendTo(select)
            .val(this.href)
            .html($(this).html());
          if ($(this).attr("class") === "selected") {
            option.attr("selected", "selected");
          }
        });
        list.remove();
      });
    },
  };
})(jQuery, Drupal);
